import { useEffect, useState } from 'react';

function getIsMainPage(): boolean {
  return window.location.pathname === '/' && !window.location.hostname.startsWith('my.');
}

export function useIsMainPage(): boolean {
  const [isMainPage, setIsMainPage] = useState(false);

  useEffect(() => {
    const update = () => setIsMainPage(getIsMainPage());

    update();

    window.addEventListener('popstate', update);

    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    history.pushState = (...args: Parameters<History['pushState']>) => {
      originalPushState(...args);
      update();
    };

    history.replaceState = (...args: Parameters<History['replaceState']>) => {
      originalReplaceState(...args);
      update();
    };

    return () => {
      window.removeEventListener('popstate', update);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  return isMainPage;
}
